/*
 * Messages
 *
 * This contains all the text for the auth component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  footer: {
    findUs: {
      id: 'footer.findUs',
      defaultMessage: 'Find us on:'
    },
    rights: {
      id: 'footer.rights',
      defaultMessage: 'Emi Labs © {year} | All rights reserved.'
    },
    madeWith: {
      id: 'footer.madeWith',
      defaultMessage: 'Made with ❤️ by'
    },
    allRightsReserved: {
      id: 'footer.allRightsReserved',
      defaultMessage: 'Emi Labs © 2022 - All rights reserved'
    },
    privacyPolicy: {
      id: 'footer.privacyPolicy',
      defaultMessage: 'Privacy Policy'
    },
    moreInfo: {
      title: {
        id: 'footer.moreInfo.title',
        defaultMessage: 'More Information'
      },
      privacy: {
        id: 'footer.moreInfo.privacy',
        defaultMessage: 'Privacy Policy'
      },
      faq: {
        id: 'footer.moreInfo.faq',
        defaultMessage: 'Frequently asked questions'
      }
    }
  }
});
